import { defineComponent } from "vue";

export default defineComponent({
  name: "sdk-mv-university-home",
  computed: {
    availableRoutes(): { name: string; key: string }[] {
      return [
        {
          name: "Dicas/Processos",
          key: "hints",
        },
        {
          name: "Editor de formulários",
          key: "editor",
        },
        {
          name: "Flow/SDK",
          key: "sdkflow",
        },
      ];
    },
  },
  methods: {
    navigateTo(product: string) {
      this.$router.push({ name: "university-lessons", params: { product } });
    },
  },
});
